import React, { useState } from "react";


const WebappRequest = () => {
  const [orderBy, setOrderBy] = useState("dateCreated");
  const [order, setOrder] = useState("desc");

  const webappList = [
    {
      id: 211,
      appName: "",
      appColour: "",
      dateCreated: "2025-03-24T12:35:00.054+00:00",
      supportEmail: null,
      emailAddress: "primebiller@gmail.com",
      businessName: "Prime Biller",
      subDomainUrl: null,
      supportPhoneNumber: null,
      status: "Pending",
      reason: null,
      faqUrl: "",
      imageUrl: "https://zeedspace.nyc3.digitaloceanspaces.com/zouse/zouse/7a03a5eb-3110-46eb-b185-7d7307eb6a60.",
    },
    {
      id: 236,
      appName: "topupbox",
      appColour: "red",
      dateCreated: "2025-03-27T08:07:48.163+00:00",
      supportEmail: "akoyetunji@gmail.com",
      emailAddress: "mobile@topupbox.com",
      businessName: "Zeedlabs mobile",
      subDomainUrl: null,
      supportPhoneNumber: 8035739280,
      status: "Pending",
      reason: null,
      faqUrl: "www.topupbox.com",
      imageUrl: "https://zeedspace.nyc3.digitaloceanspaces.com/zouse/zouse/1c091a1e-948d-48e5-8a3c-3fa1f1b716f8.png",
    },
    {
      id: 237,
      appName: "Creative",
      appColour: "#e4b9b9",
      dateCreated: "2025-03-27T08:22:10.521+00:00",
      supportEmail: "ajidaveini@gmail.com",
      emailAddress: "adekunle@zeedlabs.com",
      businessName: "topupbox",
      subDomainUrl: null,
      supportPhoneNumber: 8160843897,
      status: "Pending",
      reason: null,
      faqUrl: "https://www.figma.com/design/OT6f2RWaYDAvoGOe2rg4mD/Campaign-monk-%7C-Zeedlabs?node-id=363-3366&t=tVGjd6TmSyCu8Cn8-0",
      imageUrl: "https://zeedspace.nyc3.digitaloceanspaces.com/zouse/zouse/edb1bb7d-1cfe-4433-b61b-a1be343ef221.png",
    },
  ];

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString();
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...webappList].sort((a, b) => {
    if (orderBy === "dateCreated") {
      return order === "asc"
        ? new Date(a.dateCreated) - new Date(b.dateCreated)
        : new Date(b.dateCreated) - new Date(a.dateCreated);
    }
    return order === "asc"
      ? a[orderBy] > b[orderBy]
        ? 1
        : -1
      : a[orderBy] < b[orderBy]
      ? 1
      : -1;
  });

  return (
    <div></div>
  );
};

export default WebappRequest;